<template>
	<article class="access">
		<form @submit.prevent="search()">
			<ManagingSection :column-count="2">
				<ManagingBox title="이름/아이디">
					<div class="access__searchType">
						<Selector
							v-model="searchType"
							:optionList="serchList"
							valueKey="id"
						/>
						<input
							type="text"
							v-model="searchKeyword"
							class="input-text"
							placeholder="검색어를 입력하세요."
						/>
					</div>
				</ManagingBox>
				<ManagingBox title="등록일">
					<DateRange v-model="period" type="date" />
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button type="submit" class="btn-main blue">검색하기</button>
				<button
					type="button"
					class="btn-main blue bordered"
					@click="initFilters"
				>
					검색조건 초기화
				</button>
			</div>
		</form>
		<div class="access__total">등록: {{ contentTotal }} 건</div>
		<table class="table-main list access__table">
			<thead>
				<tr>
					<th>No.</th>
					<th>이름</th>
					<th>아이디</th>
					<th>직급</th>
					<th>아이피</th>
					<th>최근접속일</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in logList" :key="item.idLog">
					<td>{{ item.idLog }}</td>
					<td>{{ item.nickName || '-' }}</td>
					<td>{{ item.email || '-' }}</td>
					<td>{{ item.positionText || '-' }}</td>
					<td>{{ item.ipAddress || '-' }}</td>
					<td>{{ item.lastDate || '-' }}</td>
				</tr>
			</tbody>
		</table>
		<PaginationBox
			v-if="contentTotal > 0"
			:totalItem="contentTotal"
			:limit="limit"
			:offset="offset"
			:pageLengPerOne="10"
			slot="pagination"
			@to="paging($event)"
		/>
	</article>
</template>
<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import Selector from '@/components/Selector.vue';
	import DateRange from '@/components/DateRange.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import moment from 'moment';
	import { formattedDate } from '../../util';

	export default {
		components: {
			ManagingSection,
			ManagingBox,
			Selector,
			DateRange,
			PaginationBox,
		},
		data() {
			return {
				searchType: 'nickName',
				searchKeyword: '',
				period: { from: '', to: '' },
				serchList: [
					{ id: 'nickName', name: '이름' },
					{ id: 'adminId', name: '아이디' },
				],
				offset: 0,
				limit: 10,
				contentTotal: 0,
				logList: [],
				paramsKeys: [
					'nickName',
					'adminId',
					'minCreateDate',
					'maxCreateDate',
					'offset',
					'limit',
				],
			};
		},
		mounted() {
			this.setFilter();
			this.getList();
		},
		methods: {
			initFilters() {
				this.searchType = 'nickName';
				this.searchKeyword = '';
				this.period = { from: '', to: '' };
				this.offset = 0;
				this.replaceQuery();
			},
			search() {
				if (moment(this.period.from).isAfter(this.period.to)) {
					alert('시작일이 종료일보다 클 수 없습니다.');
					return;
				}
				this.replaceQuery();
				this.getList();
			},
			replaceQuery() {
				const query = this.paramsKeys.reduce((acc, key) => {
					if (['nickName', 'adminId'].includes(key)) {
						const value =
							this.searchType === key ? this.searchKeyword : '';
						if (value) acc[key] = value;
					} else if (key === 'minCreateDate') {
						const value = this.period.from.replace(/-/g, '');
						if (value) acc[key] = value;
					} else if (key === 'maxCreateDate') {
						const value = this.period.to.replace(/-/g, '');
						if (value) acc[key] = value;
					} else if (['offset', 'limit'].includes(key)) {
						acc[key] = this[key];
					}
					return acc;
				}, {});
				this.$router.replace({ query }).catch(() => {});
			},
			async getList() {
				const params = new URLSearchParams({
					offset: this.offset,
					limit: this.limit,
					minCreateDate: this.period.from,
					maxCreateDate: this.period.to,
					[this.searchType]: this.searchKeyword,
				});

				const { data } = await this.$axiosAdmin2.get(
					`/api/setting/login-logs?${params.toString()}`
				);
				this.logList = data.loginLogList.data.map(item => {
					return {
						...item,
						lastDate: item.lastDate
							? formattedDate(item.lastDate)
							: '-',
					};
				});
				this.contentTotal = data.loginLogList.contentTotal;
			},
			paging({ offset }) {
				this.offset = offset;
				this.getList();
			},
			setFilter() {
				const {
					nickName,
					adminId,
					minCreateDate,
					maxCreateDate,
					offset,
					limit,
				} = this.$route.query;
				this.searchType = nickName
					? 'nickName'
					: adminId
						? 'adminId'
						: 'nickName';
				this.searchKeyword = nickName || adminId || '';
				this.period = {
					from: minCreateDate || '',
					to: maxCreateDate || '',
				};
				this.offset = Number(offset) || 0;
				this.limit = Number(limit) || 10;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.access {
		&__total {
			margin-bottom: 15px;
			font-size: 15px;
		}

		&__searchType {
			display: flex;
			width: 100%;
			gap: 10px;
		}

		&__table {
			margin-bottom: 30px;
		}
	}
</style>
